type TrackingContext = {
  customer_id?: string
  customer_type?: string
}

// Module-level context merged into every tracked event (set by the hub/club/event screens).
let trackingContext: TrackingContext = {}

export const setTrackingContext = (ctx: TrackingContext): void => {
  const next: TrackingContext = {}
  if (ctx.customer_id !== undefined) next.customer_id = ctx.customer_id
  if (ctx.customer_type !== undefined) next.customer_type = ctx.customer_type
  trackingContext = next
}

export const track = (event: string, params?: object): void => {
  try {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event, ...trackingContext, ...params })
  } catch {
    // Tracking must never break or block the app flow.
  }
}

export const newEventId = (): string => {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID()
  } catch {
    // Fall through to the Math.random-based fallback below.
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0
    const value = char === 'x' ? random : (random & 0x3) | 0x8
    return value.toString(16)
  })
}

export const trackPurchase = (args: {
  eventId: string
  value?: number
  currency?: string
  items?: unknown[]
  registrationType?: string
}): void => {
  const params: Record<string, unknown> = {
    event_id: args.eventId,
    transaction_id: args.eventId,
  }
  if (args.value !== undefined) params.value = args.value
  if (args.currency !== undefined) params.currency = args.currency
  if (args.items !== undefined) params.items = args.items
  if (args.registrationType !== undefined) params.registration_type = args.registrationType

  track('purchase', params)
}
